import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loading } from "../components/Loading";
import { useAuth } from "./AuthContext";

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const auth = useAuth();
  const location = useLocation();

  if (auth.state === "initializing") {
    return <Loading message="ログイン情報を確認しています..." />;
  }

  if (auth.state !== "authenticated") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};
